<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <b-button variant="outline-primary" class="me-2">
          <i class="mc-fa icon-outline_arrow-left"></i> {{ $t('global.back') }}
        </b-button>
        <b-button variant="primary">
          <i class="mc-fa icon-outline_download"></i> {{ $t('global.action.download') }}
        </b-button>
      </div>
    </div>
    <div class="text-end my-3">
      <b-button variant="outline-primary" v-b-modal.modal-parameter>
        <i class="mc-fa icon-outline_funnel"></i> Parameter Laporan
      </b-button>
    </div>
    <b-card class="mc-form mc-report__route-geolocation">
      <b-card-title>Ringkasan Data</b-card-title>
      <div class="mc-list-info__top mb-4 mt-2">
        <div>
          <span>Periode Laporan</span>
          <strong>210 Km</strong>
        </div>
        <div>
          <span>Geolokasi Mulai</span>
          <strong>Jogja</strong>
        </div>
        <div>
          <span>Geolokasi Selesai</span>
          <strong>Surabaya 3</strong>
        </div>
        <div>
          <span>Geolokasi yang Dilewati</span>
          <strong>Tuban, Lamongan, Gresik</strong>
        </div>
      </div>
      <b-row>
        <b-col md="6">
          <GeolocationrouteValue />
        </b-col>
        <b-col md="6">
          <GeolocationrouteGraph />
        </b-col>
      </b-row>
    </b-card>
    <b-card class="mc-report__route-geolocation-table">
      <GeolocationrouteTable />
    </b-card>
    <ModalParameter />
  </Layout>
</template>
    <script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import GeolocationrouteValue from './Value'
import GeolocationrouteGraph from './Graph'
import GeolocationrouteTable from './Table'
import ModalParameter from './Modal/Parameter'
export default {
  page: {
    title: 'Report',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    GeolocationrouteValue,
    GeolocationrouteGraph,
    GeolocationrouteTable,
    ModalParameter,
  },
  computed: {
    title() {
      return 'Geolokasi Rute'
    },
  },
}
</script>